// src/ManagerDashboard.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';

import DashboardIcon  from '@mui/icons-material/Dashboard';
import PeopleIcon     from '@mui/icons-material/People';
import MessageIcon    from '@mui/icons-material/Message';
import AssessmentIcon from '@mui/icons-material/Assessment';

import ManagerOverviewPage  from './pages/manager/ManagerOverviewPage';
import ManagerPartnersPage  from './pages/manager/ManagerPartnersPage';
import ManagerMessagesPage  from './pages/manager/ManagerMessagesPage';
import ManagerReportsPage   from './pages/manager/ManagerReportsPage';

const managerMenuItems = [
    { text: 'Visão Geral',    path: '/manager/dashboard',  icon: <DashboardIcon /> },
    { text: 'Meus Parceiros', path: '/manager/parceiros',  icon: <PeopleIcon /> },
    { text: 'Mensagens',      path: '/manager/mensagens',  icon: <MessageIcon /> },
    { text: 'Relatórios',     path: '/manager/relatorios', icon: <AssessmentIcon /> },
];

function ManagerDashboard({ userProfile, onFirstAccessComplete }) {
    return (
        <DashboardLayout
            menuItems={managerMenuItems}
            pageTitle="Painel do Gerente"
            userProfile={userProfile}
            onFirstAccessComplete={onFirstAccessComplete}
        >
            <Routes>
                <Route path="/"           element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard"   element={<ManagerOverviewPage />} />
                <Route path="parceiros"   element={<ManagerPartnersPage />} />
                <Route path="mensagens"   element={<ManagerMessagesPage />} />
                <Route path="relatorios"  element={<ManagerReportsPage />} />
            </Routes>
        </DashboardLayout>
    );
}

export default ManagerDashboard;
